import Alert from 'core/components/Alert'
import SimpleLink from 'core/components/SimpleLink'
import Text from 'core/elements/Text'
import { makeStyles } from '@material-ui/styles'
import Theme from 'core/themes/model'
import React from 'react'

export const NodeGroupsNotFullyHealthyAlert = () => {
  return (
    <Alert title="Node groups are not fully healthy" variant="primary">
      <Text variant="body2">
        Upgrade can still be performed but in order to prevent any problems that may arise after
        improvement, it is recommended to only upgrade fully healthy Node Groups.
      </Text>
      <SimpleLink>Check Node Groups Health Status</SimpleLink>
    </Alert>
  )
}

export const UnhealthyNodeGroupsAlert = () => {
  return (
    <Alert title="Incorrect node groups health status" variant="error">
      <Text variant="body2">
        Upgrade cannot be performed because of the bad health status of some node groups.
      </Text>
      <SimpleLink>Check Node Groups Health Status</SimpleLink>
    </Alert>
  )
}

export const DepreciatedVersionAlert = ({
  deprecatedVersion = '1.21',
  date = '2022-02-28',
  newVersion = '1.23',
}) => {
  return (
    <Alert title={`This cluster uses Kubernetes ${deprecatedVersion} version`} variant="primary">
      <Text variant="body2">
        Kubernetes <b>{deprecatedVersion}</b> has been deprecated as of <b>{date}</b>
      </Text>
      <Text variant="body2">
        Cluster should be upgraded to at least <b>{newVersion}</b> version
      </Text>
    </Alert>
  )
}

export const EndOfLifeVersionAlert = ({
  oldVersion = '1.21',
  date = '2022-02-28',
  newVersion = '1.24',
}) => {
  return (
    <Alert title={`This cluster uses Kubernetes ${oldVersion} version`} variant="error">
      <Text variant="body2">
        Kubernetes <b>{oldVersion}</b> has reached End of Life as of <b>{date}</b>
      </Text>
      <Text variant="body2">
        Cluster should be upgraded to at least <b>{newVersion}</b> version
      </Text>
    </Alert>
  )
}

const useStyles = makeStyles((theme: Theme) => ({
  clusterName: {
    fontWeight: 'normal',
  },
  currAndLatestVersions: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  alert: {
    marginBottom: theme.spacing(2),
  },
}))
